/* Product page: gallery + sticky mobile CTA + variant select price sync. */
(function () {
  'use strict';

  /* Gallery */
  var gallery = document.querySelector('[data-product-gallery]');
  if (gallery) {
    var slides = gallery.querySelectorAll('[data-gallery-slide]');
    var thumbs = gallery.querySelectorAll('[data-gallery-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var id = thumb.dataset.mediaId;
        slides.forEach(function (s) { s.classList.toggle('is-active', s.dataset.mediaId === id); });
        thumbs.forEach(function (t) {
          var active = t === thumb;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      });
    });
  }

  /* Sticky mobile CTA: show once main CTA scrolls out of view */
  var sticky = document.querySelector('[data-product-sticky]');
  var mainAdd = document.querySelector('[data-main-add]');
  if (sticky && mainAdd && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      var visible = entries[0].isIntersecting;
      sticky.classList.toggle('is-visible', !visible);
      sticky.setAttribute('aria-hidden', visible ? 'true' : 'false');
    }, { rootMargin: '-64px 0px 0px 0px' });
    io.observe(mainAdd);
  }
})();
